import React,{Component} from 'react'
import FrameComponents from '../FrameComponents';
import './index.css'
import './common/index.css'
class dashboard extends Component {
  // 进入组件调用
  state = {
    name: 'product-management'
  }
  componentDidMount() {
    // 设置页面标题
    document.title = 'DropshipMan-product-management';
  }
 
  render() {
    return (
      <div>
        <FrameComponents name={this.state.name} /> 
      </div>
    );
    
  }
}

export default dashboard;

